import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import FormRegisterView from './FormRegisterView';

class RecapRegisterView extends Component {

  render() {
    const {inProgress, t, errors, handleChange, registerUser, registerData, handleSubmit, passwordCallback, language} = this.props;
    return (
      <form className='form' onSubmit={handleSubmit}>
        <div className='products__cart-register'>
          <FormRegisterView
            state={registerData}
            errors={errors}
            handleChange={handleChange}
            passwordCallback={passwordCallback}
            language={language}
          />
          <input
            type='submit'
            className='form__button'
            onClick={registerUser}
            value={t('register')}
            disabled={inProgress || !registerData.isAgree}
          />
        </div>
      </form>
    );
  }
}

RecapRegisterView.propTypes = {
  errors: PropTypes.object,
  inProgress: PropTypes.bool
};

export default translate('translations')(RecapRegisterView);



// WEBPACK FOOTER //
// ./src/components/Customer/Auth/RecapRegisterView.js